var lib_core     = require("lib-core");

var ProcessMesssageModel = function() {
    lib_core.Model.apply(this,arguments);
    var self = this;

    this.currentLoads = this.map("currentLoads", true);
    
    this.visible = this.value("visible", true);

    this.message = this.value("message", true);
    this.message("");

    this.currentLoads.onPut("loadAdd", function(info){
         self._setMessage();
         self.visible(true);
    });

    this.currentLoads.onRemove("loadRemove", function(info){
         self._setMessage();
        
         if(self.currentLoads.size() == 0)
            self.visible(false);
    })
};

lib_core.inherit(ProcessMesssageModel, lib_core.Model);
ProcessMesssageModel.$class = "ProcessMesssageModel";

ProcessMesssageModel.prototype.addLoad = function(name, details){
    if(details == null || details == undefined) details = "";

    this.currentLoads.put(name, details);
}

ProcessMesssageModel.prototype.changeDetails = function(name, details){
    this.currentLoads.put(name, details);
    this._setMessage();
}

ProcessMesssageModel.prototype.removeLoad = function(name){
    this.currentLoads.remove(name);
}


ProcessMesssageModel.prototype._setMessage = function(){
    var message = "";
    this.currentLoads.forEach(function(name, details){
        if(details != "") message += details + '<br>';
    });
    this.message(message);
}

module.exports = ProcessMesssageModel;

